module.exports = __webpack_public_path__ + "static/media/kutii_gashi_drob1.673cbcda.jfif";


//////////////////
// WEBPACK FOOTER
// ./src/images/sales/kutii_gashi_drob1.jfif
// module id = 235
// module chunks = 0